//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BudgetlyApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    categories_getCategories(api_version: any | undefined): Promise<CategoryDtoListApiResponse> {
        let url_ = this.baseUrl + "/categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_getCategories(_response);
        });
    }

    protected processCategories_getCategories(response: Response): Promise<CategoryDtoListApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryDtoListApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryDtoListApiResponse>(null as any);
    }

    /**
     * @param name (optional) 
     * @param isArchived (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    categories_createCategory(name: string | null | undefined, isArchived: boolean | undefined, api_version: any | undefined): Promise<CategoryAggregateApiResponse> {
        let url_ = this.baseUrl + "/categories?";
        if (name !== undefined && name !== null)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_createCategory(_response);
        });
    }

    protected processCategories_createCategory(response: Response): Promise<CategoryAggregateApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryAggregateApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryAggregateApiResponse>(null as any);
    }

    /**
     * @param utcMonth (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    categories_getCategoryWithPlans(utcMonth: Date | null | undefined, api_version: any | undefined): Promise<CategoriesSummaryApiResponse> {
        let url_ = this.baseUrl + "/categories/plans?";
        if (utcMonth !== undefined && utcMonth !== null)
            url_ += "utcMonth=" + encodeURIComponent(utcMonth ? "" + utcMonth.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_getCategoryWithPlans(_response);
        });
    }

    protected processCategories_getCategoryWithPlans(response: Response): Promise<CategoriesSummaryApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoriesSummaryApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoriesSummaryApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    categories_getCategory(id: string, api_version: any | undefined): Promise<CategoryAggregateApiResponse> {
        let url_ = this.baseUrl + "/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_getCategory(_response);
        });
    }

    protected processCategories_getCategory(response: Response): Promise<CategoryAggregateApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryAggregateApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryAggregateApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    categories_updateCategory(id: string, api_version: any | undefined, body: CreateCategoryInputModel | undefined): Promise<CategoryAggregateApiResponse> {
        let url_ = this.baseUrl + "/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_updateCategory(_response);
        });
    }

    protected processCategories_updateCategory(response: Response): Promise<CategoryAggregateApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryAggregateApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryAggregateApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    categories_deleteCategory(id: string, api_version: any | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/categories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategories_deleteCategory(_response);
        });
    }

    protected processCategories_deleteCategory(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    categoryPlan_createExpensePlan(api_version: any | undefined, body: CreateCategoryPlanInputModel | undefined): Promise<CategoryAggregateApiResponse> {
        let url_ = this.baseUrl + "/category/plan";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCategoryPlan_createExpensePlan(_response);
        });
    }

    protected processCategoryPlan_createExpensePlan(response: Response): Promise<CategoryAggregateApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoryAggregateApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoryAggregateApiResponse>(null as any);
    }

    /**
     * @param amount (optional) 
     * @param currency (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    currencies_convertToEur(amount: number | undefined, currency: string | null | undefined, api_version: any | undefined): Promise<DecimalApiResponse> {
        let url_ = this.baseUrl + "/convert-to-eur?";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        if (currency !== undefined && currency !== null)
            url_ += "currency=" + encodeURIComponent("" + currency) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrencies_convertToEur(_response);
        });
    }

    protected processCurrencies_convertToEur(response: Response): Promise<DecimalApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DecimalApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DecimalApiResponse>(null as any);
    }

    /**
     * @param categoryId (optional) 
     * @param period (optional) 
     * @param utcStart (optional) 
     * @param utcEnd (optional) 
     * @param api_version (optional) 
     * @return Success
     */
    expenses_getCurrentExpenses(categoryId: string | null | undefined, period: FilterPeriod | undefined, utcStart: Date | null | undefined, utcEnd: Date | null | undefined, api_version: any | undefined): Promise<ExpenseSummaryDtoApiResponse> {
        let url_ = this.baseUrl + "/expense?";
        if (categoryId !== undefined && categoryId !== null)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (period === null)
            throw new Error("The parameter 'period' cannot be null.");
        else if (period !== undefined)
            url_ += "Period=" + encodeURIComponent("" + period) + "&";
        if (utcStart !== undefined && utcStart !== null)
            url_ += "UtcStart=" + encodeURIComponent(utcStart ? "" + utcStart.toISOString() : "") + "&";
        if (utcEnd !== undefined && utcEnd !== null)
            url_ += "UtcEnd=" + encodeURIComponent(utcEnd ? "" + utcEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_getCurrentExpenses(_response);
        });
    }

    protected processExpenses_getCurrentExpenses(response: Response): Promise<ExpenseSummaryDtoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpenseSummaryDtoApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseSummaryDtoApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    expenses_createExpense(api_version: any | undefined, body: CreateExpenseDto | undefined): Promise<ExpenseDtoApiResponse> {
        let url_ = this.baseUrl + "/expense";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_createExpense(_response);
        });
    }

    protected processExpenses_createExpense(response: Response): Promise<ExpenseDtoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpenseDtoApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDtoApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    expenses_getExpense(id: string, api_version: any | undefined): Promise<ExpenseDtoApiResponse> {
        let url_ = this.baseUrl + "/expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_getExpense(_response);
        });
    }

    protected processExpenses_getExpense(response: Response): Promise<ExpenseDtoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpenseDtoApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDtoApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    expenses_updateExpense(id: string, api_version: any | undefined, body: UpdateExpenseDto | undefined): Promise<ExpenseDtoApiResponse> {
        let url_ = this.baseUrl + "/expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_updateExpense(_response);
        });
    }

    protected processExpenses_updateExpense(response: Response): Promise<ExpenseDtoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpenseDtoApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDtoApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    expenses_deleteExpense(id: string, api_version: any | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/expense/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_deleteExpense(_response);
        });
    }

    protected processExpenses_deleteExpense(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    expenses_createCategoriesFromExpenses(api_version: any | undefined): Promise<ExpenseDtoListApiResponse> {
        let url_ = this.baseUrl + "/expense/categories/create-categories-from-expenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExpenses_createCategoriesFromExpenses(_response);
        });
    }

    protected processExpenses_createCategoriesFromExpenses(response: Response): Promise<ExpenseDtoListApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExpenseDtoListApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExpenseDtoListApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    newUser_getUser(api_version: any | undefined): Promise<GetUserResponseApiResponse> {
        let url_ = this.baseUrl + "/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewUser_getUser(_response);
        });
    }

    protected processNewUser_getUser(response: Response): Promise<GetUserResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserResponseApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error404NotFoundResponse;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserResponseApiResponse>(null as any);
    }

    /**
     * @param api_version (optional) 
     * @return Success
     */
    newUser_getUserProfile(username: string | null, api_version: any | undefined): Promise<PublicUserProfileDtoApiResponse> {
        let url_ = this.baseUrl + "/profile/{username}";
        if (username === undefined || username === null)
            throw new Error("The parameter 'username' must be defined.");
        url_ = url_.replace("{username}", encodeURIComponent("" + username));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewUser_getUserProfile(_response);
        });
    }

    protected processNewUser_getUserProfile(response: Response): Promise<PublicUserProfileDtoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicUserProfileDtoApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicUserProfileDtoApiResponse>(null as any);
    }

    /**
     * Change user's password
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    newUser_changePassword(api_version: any | undefined, body: PasswordChangeDto | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/change-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewUser_changePassword(_response);
        });
    }

    protected processNewUser_changePassword(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(null as any);
    }

    /**
     * Request JWT token for authentication. Requires confirmation token.
    The user's password will also be changed.
     * @param api_version (optional) 
     * @param body (optional) Contains the username and password and confirmation token
     * @return Success
     */
    newUser_authenticateWithToken(api_version: any | undefined, body: AuthenticateWithTokenRequest | undefined): Promise<UserJwtTokenResponseApiResponse> {
        let url_ = this.baseUrl + "/authenticate-with-token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewUser_authenticateWithToken(_response);
        });
    }

    protected processNewUser_authenticateWithToken(response: Response): Promise<UserJwtTokenResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserJwtTokenResponseApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserJwtTokenResponseApiResponse>(null as any);
    }

    /**
     * Sends a forgotten password email containing a confirmation token.
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    newUser_sendForgottenPasswordEmail(api_version: any | undefined, body: UserWantsForgottenPasswordRequest | undefined): Promise<MessageResponseBaseApiResponse> {
        let url_ = this.baseUrl + "/send-reset-password-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNewUser_sendForgottenPasswordEmail(_response);
        });
    }

    protected processNewUser_sendForgottenPasswordEmail(response: Response): Promise<MessageResponseBaseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessageResponseBaseApiResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error404NotFoundResponse;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessageResponseBaseApiResponse>(null as any);
    }

    /**
     * Creates a new user account.
     * @param api_version (optional) 
     * @param body (optional) Contains the account creation details.
     * @return Success
     */
    user_createAccount(api_version: any | undefined, body: UserCreateAccountRequest | undefined): Promise<UserJwtTokenResponse> {
        let url_ = this.baseUrl + "/user/create-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_createAccount(_response);
        });
    }

    protected processUser_createAccount(response: Response): Promise<UserJwtTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserJwtTokenResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error409ConflictResponse;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserJwtTokenResponse>(null as any);
    }

    /**
     * Update a user account
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Success
     */
    user_updateAccount(api_version: any | undefined, body: UserUpdateRequest | undefined): Promise<GetUserResponse> {
        let url_ = this.baseUrl + "/user/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_updateAccount(_response);
        });
    }

    protected processUser_updateAccount(response: Response): Promise<GetUserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUserResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error409ConflictResponse;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetUserResponse>(null as any);
    }

    /**
     * Checks whether the specified username is in use
     * @param api_version (optional) 
     * @param body (optional) Contains the request details
     * @return Success
     */
    user_userNameExists(api_version: any | undefined, body: UsernameExistsRequest | undefined): Promise<ExistenceResponse> {
        let url_ = this.baseUrl + "/user/username-exists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_userNameExists(_response);
        });
    }

    protected processUser_userNameExists(response: Response): Promise<ExistenceResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistenceResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistenceResponse>(null as any);
    }

    /**
     * Checks if email is valid, not single use email and there is no user with such email.
     * @param api_version (optional) 
     * @param body (optional) 
     * @return Email is valid and free.
     */
    user_analyzeEmail(api_version: any | undefined, body: AnalyzeEmailRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/user/analyze-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_analyzeEmail(_response);
        });
    }

    protected processUser_analyzeEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 406) {
            return response.text().then((_responseText) => {
            let result406: any = null;
            result406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AnalyzeEmailResponse;
            return throwException("Email is not valid.", status, _responseText, _headers, result406);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error409ConflictResponse;
            return throwException("Email already taken.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Request JWT token for authentication
     * @param api_version (optional) 
     * @param body (optional) Contains the username and password
     * @return Success
     */
    user_authenticate(api_version: any | undefined, body: UserAuthChallengeEmailOrUsernameRequest | undefined): Promise<UserJwtTokenResponse> {
        let url_ = this.baseUrl + "/user/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser_authenticate(_response);
        });
    }

    protected processUser_authenticate(response: Response): Promise<UserJwtTokenResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserJwtTokenResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error400BadRequest;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Error404NotFoundResponse;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserJwtTokenResponse>(null as any);
    }
}

export interface CategoryDto {
    id?: string;
    name?: string | null;
}

export interface CategoryDtoListApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: CategoryDto[] | null;
}

/** <br/><br/>Values:<br/>0 = Trace<br/>1 = Debug<br/>2 = Information<br/>3 = Warning<br/>4 = Error<br/>5 = Critical<br/>6 = None */
export enum LogLevel {
    Trace = "Trace",
    Debug = "Debug",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
}

export interface Error400BadRequest {
    errors?: { [key: string]: string[]; } | null;
    title?: string | null;
    traceId?: string | null;
    readonly isSuccess?: boolean;
    loggingLevel?: LogLevel;
    readonly message?: string | null;
}

export interface CategoryPlanDto {
    planId?: string;
    month?: Date;
    limit?: number;
}

export interface CategoryAggregate {
    id?: string;
    name?: string | null;
    isArchived?: boolean;
    plan?: CategoryPlanDto;
    expenses?: number | null;
}

export interface CategoryAggregateApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: CategoryAggregate;
}

export interface CategoriesSummary {
    categories?: CategoryAggregate[] | null;
    totalPlanned?: number;
    totalSpent?: number;
}

export interface CategoriesSummaryApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: CategoriesSummary;
}

export interface CreateCategoryInputModel {
    name?: string | null;
    isArchived?: boolean;
}

export interface ApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: any | null;
}

export interface CreateCategoryPlanInputModel {
    categoryId?: string;
    month?: Date;
    limit?: number;
}

export interface DecimalApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: number;
}

export enum FilterPeriod {
    None = "None",
    ThisDay = "ThisDay",
    Yesterday = "Yesterday",
    ThisWeek = "ThisWeek",
    LastWeek = "LastWeek",
    ThisMonth = "ThisMonth",
    LastMonth = "LastMonth",
    Everything = "Everything",
    Custom = "Custom",
}

export interface ExpenseAggregation {
    id?: string;
    creatorId?: string;
    utcCreated?: Date;
    utcRecorded?: Date;
    amount?: number;
    currency?: string | null;
    description?: string | null;
    categoryId?: string;
    categoryDto?: CategoryDto;
}

export interface ExpenseSummaryDto {
    expenses?: ExpenseAggregation[] | null;
    saldo?: number;
}

export interface ExpenseSummaryDtoApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: ExpenseSummaryDto;
}

export interface CreateExpenseDto {
    amount?: number;
    currency?: string | null;
    category?: string | null;
    categoryId?: string;
    description?: string | null;
    utcRecorded?: Date;
}

export interface ExpenseDto {
    id?: string;
    creatorId?: string;
    utcCreated?: Date;
    utcRecorded?: Date;
    amount?: number;
    currency?: string | null;
    categoryId?: string;
    category?: CategoryDto;
    description?: string | null;
}

export interface ExpenseDtoApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: ExpenseDto;
}

export interface UpdateExpenseDto {
    amount?: number;
    currency?: string | null;
    category?: string | null;
    categoryId?: string;
    description?: string | null;
    utcRecorded?: Date;
}

export interface ExpenseDtoListApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: ExpenseDto[] | null;
}

export interface UserProfileResponse {
    /** User's country. */
    country?: string | null;
    /** URL to user's profile image. */
    avatarUrl?: string | null;
    /** Locale of the user. */
    locale?: string | null;
    /** About user. */
    about?: string | null;
    primaryLanguage?: string | null;
}

export interface Version {
    readonly major?: number;
    readonly minor?: number;
    readonly build?: number;
    readonly revision?: number;
    readonly majorRevision?: number;
    readonly minorRevision?: number;
}

export interface IRequestContext {
    readonly isAuthenticated?: boolean;
    readonly userId?: string;
    readonly authenticationToken?: string | null;
    readonly issuer?: string | null;
    clientApiVersion?: Version;
}

export interface GetUserResponse {
    firstName?: string | null;
    lastName?: string | null;
    readonly fullName?: string | null;
    /** Account creation time. */
    utcCreated?: Date;
    /** Last account update time. */
    utcUpdated?: Date;
    /** Last account authentication time. */
    utcLastAuthentication?: Date;
    /** The user's current roles */
    roles?: string[] | null;
    /** The user's email address */
    email?: string | null;
    /** The user's username if it exists. */
    username?: string | null;
    /** Is the user's account verified either by email or mobile number. */
    isAccountVerified?: boolean;
    /** Is the user's account verified by email. */
    isEmailValidated?: boolean;
    profile?: UserProfileResponse;
    /** The user's unique identifier, specified as a 12-bit hexadecimal ObjectId */
    userId: string;
}

export interface GetUserResponseApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: GetUserResponse;
}

export interface Error404NotFoundResponse {
    readonly isSuccess?: boolean;
    loggingLevel?: LogLevel;
    readonly message?: string | null;
}

export interface HowtoEngagementDto {
    howtoCount?: number;
    commentCount?: number;
    viewCount?: number;
}

export interface PublicUserProfileDto {
    avatarUrl?: string | null;
    fullName?: string | null;
    username?: string | null;
    about?: string | null;
    email?: string | null;
    utcMemberSince?: Date | null;
    engagement?: HowtoEngagementDto;
}

export interface PublicUserProfileDtoApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: PublicUserProfileDto;
}

export interface PasswordChangeDto {
    oldPswd?: string | null;
    newPswd?: string | null;
}

export interface AuthenticateWithTokenRequest {
    /** The confirmation token received in the 'forgotten password' email */
    confirmationToken: string;
    /** The password must be at least 8 characters long, contain a digit and an uppercase character. */
    password: string;
    /** The email address of this account */
    email: string;
}

export interface IUserResponse {
    userId?: string;
    /** The user's current roles */
    roles?: string[] | null;
    /** The user's email address */
    email?: string | null;
    isAccountVerified?: boolean;
}

export interface UserJwtTokenResponse {
    user?: GetUserResponse;
    /** A newly generated JWT token to authenticate endpoints. */
    token?: string | null;
}

export interface UserJwtTokenResponseApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: UserJwtTokenResponse;
}

export interface UserWantsForgottenPasswordRequest {
    /** The email address of this account */
    email: string;
}

export interface MessageResponseBase {
    isSuccess?: boolean;
    readonly message?: string | null;
}

export interface MessageResponseBaseApiResponse {
    ok?: boolean;
    message?: string | null;
    messageId?: string | null;
    messageArgs?: { [key: string]: any; } | null;
    data?: MessageResponseBase;
}

export interface UserCreateAccountRequest {
    /** User's username. */
    username: string;
    /** Email of user. */
    email?: string | null;
    /** The locale string of newly created user (xx-YY, e.g. 'en-GB'). */
    locale?: string | null;
    /** The standard which is used to encode the Locale field (supported: 'ISO639'). */
    localeStandard?: string | null;
    /** User's language. */
    language: string;
    /** Has to be accepted to create an account. */
    acceptLicense?: boolean;
    /** The password must be at least 8 characters long, contain a digit and an uppercase character. */
    password: string;
}

export interface Error409ConflictResponse {
    readonly isSuccess?: boolean;
    loggingLevel?: LogLevel;
    readonly message?: string | null;
}

export interface UserUpdateRequest {
    /** User's last name. Null if field should not be modified. */
    firstName?: string | null;
    /** User's first name. Null if field should not be modified. */
    lastName?: string | null;
    /** User's bio. Null if field should not be modified. */
    about?: string | null;
    /** The user's unique identifier, optional. If not specified the current caller's userid will be used. */
    userId?: string | null;
}

export interface UsernameExistsRequest {
    /** The username to check */
    username?: string | null;
}

export interface ExistenceResponse {
    exists?: boolean;
}

/** User's email request. */
export interface AnalyzeEmailRequest {
    /** User's email which should be checked. */
    email: string;
}

/** Email validity states.<br/><br/>Values:<br/>0 = NotExists<br/>1 = InvalidFormat<br/>2 = SingleUseDomain<br/>3 = Exists */
export enum EmailValidity {
    NotExists = "NotExists",
    InvalidFormat = "InvalidFormat",
    SingleUseDomain = "SingleUseDomain",
    Exists = "Exists",
}

/** Email check response. */
export interface AnalyzeEmailResponse {
    result?: EmailValidity;
}

export interface UserAuthChallengeEmailOrUsernameRequest {
    usernameOrEmail?: string | null;
    /** The password must be at least 8 characters long, contain a digit and an uppercase character. */
    password: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}